// import React, { useState } from "react";
// import showErrorToast from "../../components/CustomComponents/toast/toast";
// import showSuccessToast from "../../components/CustomComponents/toast/toast"; // Assuming this exists
// import CustomModal from "../../components/CustomComponents/modal/customModal";
// import PaymentMethodModal from "./paymentMethodModal";

// function SubscriptionModal({
//   isModalOpen,
//   setIsModalOpen,
//   onSubscriptionSubmit,
//   compID,
// }) {
//   const [isPaymentModalOpen, setIsPaymentModalOpen] = useState(false);
//   const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null);

//   const handleCloseModal = () => {
//     setIsModalOpen(false);
//     setSelectedPaymentMethod(null);
//   };

//   const handlePaymentMethodSubmit = (paymentData, isUpdate) => {
//     setSelectedPaymentMethod(paymentData);
//     setIsPaymentModalOpen(false);
//     showSuccessToast(
//       `Payment method ${isUpdate ? "updated" : "added"} successfully`
//     );
//   };

//   const handleSubscribe = () => {
//     if (!selectedPaymentMethod) {
//       showErrorToast("Please add a payment method to subscribe");
//       return;
//     }

//     onSubscriptionSubmit(selectedPaymentMethod);
//     setIsModalOpen(false);
//     setSelectedPaymentMethod(null);
//   };

//   // Function to get card icon based on card type
//   const getCardIcon = (cardType) => {
//     switch (cardType?.toLowerCase()) {
//       case "visa":
//         return <i className="bi bi-credit-card-2-front-fill text-primary me-2"></i>;
//       case "mastercard":
//         return <i className="bi bi-credit-card-fill text-danger me-2"></i>;
//       case "amex":
//         return <i className="bi bi-credit-card-2-back-fill text-success me-2"></i>;
//       default:
//         return <i className="bi bi-credit-card me-2"></i>;
//     }
//   };

//   return (
//     <CustomModal
//       isOpen={isModalOpen}
//       onClose={handleCloseModal}
//       onSubmit={handleSubscribe}
//       title="Subscribe to ServeIQ for Restaurants Plus"
//       showButton={true}
//       isCentered={true}
//       submitButtonText="Subscribe"
//     >
//       <div className="mb-4">
//         <h5>£30 per location + £15 per kiosk per month</h5>
//         <p className="text-muted">
//           You'll be billed a prorated amount for the remaining month, then £30
//           per location plus £15 per kiosk on the first of each subsequent month.
//           VAT may apply. You can pause or cancel your subscription anytime via
//           the Pricing and Subscriptions page in the ServeIQ Dashboard. For
//           details, check our{" "}
//           <a href="#support" className="text-primary">
//             Support Centre
//           </a>.
//         </p>
//       </div>

//       <div className="mb-4">
//         <h6 className="mb-3">Payment Method</h6>
//         <p className="text-muted mb-3">
//           ServeIQ accepts most major credit and debit cards.
//         </p>
//         {selectedPaymentMethod ? (
//           <div
//             className="border p-3 rounded d-flex align-items-center justify-content-between"
//             style={{
//               backgroundColor: "#f8f9fa",
//               borderRadius: "10px",
//               boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
//             }}
//           >
//             <div className="d-flex align-items-center">
//               {getCardIcon(selectedPaymentMethod.cardType)}
//               <div>
//                 <p className="mb-0 fw-bold">
//                   {selectedPaymentMethod.cardType.toUpperCase()} ending in{" "}
//                   {selectedPaymentMethod.cardNumber.slice(-4)}
//                 </p>
//                 <p className="text-muted mb-0">
//                   Expires {selectedPaymentMethod.expiryDate}
//                 </p>
//               </div>
//             </div>
//             <button
//               className="btn btn-link text-primary p-0"
//               onClick={() => setIsPaymentModalOpen(true)}
//               style={{ textDecoration: "none", fontWeight: "600" }}
//             >
//               Change
//             </button>
//           </div>
//         ) : (
//           <div
//             className="border p-3 rounded text-center"
//             style={{
//               backgroundColor: "#f8f9fa",
//               borderStyle: "dashed",
//               borderColor: "#ccc",
//             }}
//           >
//             <p className="text-muted mb-2">No payment method added</p>
//             <button
//               className="btn btn-primary"
//               onClick={() => setIsPaymentModalOpen(true)}
//               style={{
//                 fontFamily: "Open Sans, sans-serif",
//                 fontWeight: "600",
//                 borderRadius: "10px",
//                 padding: "8px 16px",
//                 backgroundColor: "#41848F",
//                 border: "none",
//               }}
//             >
//               Add Payment Method
//             </button>
//           </div>
//         )}
//       </div>

//       <PaymentMethodModal
//         isModalOpen={isPaymentModalOpen}
//         setIsModalOpen={setIsPaymentModalOpen}
//         onPaymentMethodSubmit={handlePaymentMethodSubmit}
//         compID={compID}
//         paymentMethodToEdit={selectedPaymentMethod}
//       />
//     </CustomModal>
//   );
// }

// export default SubscriptionModal;





import React, { useState } from "react";
import showErrorToast from "../../components/CustomComponents/toast/toast";
import CustomModal from "../../components/CustomComponents/modal/customModal";
import FormInput from "../../components/CustomComponents/Input/formInput";

function SubscriptionModal({
  isModalOpen,
  setIsModalOpen,
  onSubscriptionSubmit,
  compID,
}) {
  const [paymentData, setPaymentData] = useState({
    cardNumber: "",
    cardHolderName: "",
    expiryDate: "",
    cvv: "",
  });

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setPaymentData({
      cardNumber: "",
      cardHolderName: "",
      expiryDate: "",
      cvv: "",
    });
  };

  const handleSubscribe = () => {
    try {
      if (!paymentData.cardNumber || paymentData.cardNumber.trim().length === 0) {
        showErrorToast("Please enter a valid card number");
        return;
      }

      if (
        !paymentData.cardHolderName ||
        paymentData.cardHolderName.trim().length === 0
      ) {
        showErrorToast("Please enter card holder name");
        return;
      }

      if (
        !paymentData.expiryDate ||
        paymentData.expiryDate.trim().length === 0
      ) {
        showErrorToast("Please enter expiry date");
        return;
      }

      if (!paymentData.cvv || paymentData.cvv.trim().length === 0) {
        showErrorToast("Please enter CVV");
        return;
      }

      const formattedCardNumber = paymentData.cardNumber
        .replace(/\s/g, "")
        .replace(/(\d{4})/g, "$1 ")
        .trim();

      const submitData = {
        ID: 0,
        cardNumber: formattedCardNumber,
        cardHolderName: paymentData.cardHolderName,
        expiryDate: paymentData.expiryDate,
        cvv: paymentData.cvv,
        compID: compID,
        updateDateTime: new Date().toISOString(),
      };

      onSubscriptionSubmit(submitData);
      setIsModalOpen(false);
      setPaymentData({
        cardNumber: "",
        cardHolderName: "",
        expiryDate: "",
        cvv: "",
      });
    } catch (err) {
      showErrorToast("Something went wrong.");
    }
  };

  const handleCardNumberChange = (e) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, "");
    const truncated = digits.substring(0, 16);
    const formatted = truncated.replace(/(\d{4})/g, "$1 ").trim();

    setPaymentData({
      ...paymentData,
      cardNumber: formatted,
    });
  };

  const handleExpiryDateChange = (e) => {
    const value = e.target.value;
    const digits = value.replace(/\D/g, "");
    let formatted = digits;
    if (digits.length > 2) {
      formatted = `${digits.substring(0, 2)}/${digits.substring(2, 4)}`;
    }

    setPaymentData({
      ...paymentData,
      expiryDate: formatted,
    });
  };

  const handleCvvChange = (e) => {
    const value = e.target.value;
    const cvv = value.replace(/\D/g, "").substring(0, 4);

    setPaymentData({
      ...paymentData,
      cvv,
    });
  };

  return (
    <CustomModal
      isOpen={isModalOpen}
      onClose={handleCloseModal}
      onSubmit={handleSubscribe}
      title="Subscribe to ServeIQ for Restaurants Plus"
      subtitle="ServeIQ supports a wide range of major credit and debit cards."
      showButton={true}
      isCentered={true}
      submitButtonText="Subscribe"
    >
      <div className="mb-4">
        <h5>£30 per location + £15 per kiosk per month</h5>
        <p className="text-muted">
          You'll be billed a prorated amount for the remaining month, then £30
          per location plus £15 per kiosk on the first of each subsequent month.
          VAT may apply. You can pause or cancel your subscription anytime via
          the Pricing and Subscriptions page in the ServeIQ Dashboard. For
          details, check our{" "}
          <a href="#support" className="text-primary">
            Support Centre
          </a>.
        </p>
      </div>

      <div className="mb-4">
        <h6 className="mb-3">Payment Method</h6>
        <div className="row g-3">
          <div className="col-md-12">
            <FormInput
              label="Card Number"
              placeHolder="XXXX XXXX XXXX XXXX"
              type="text"
              value={paymentData.cardNumber}
              onchange={handleCardNumberChange}
              required
            />
          </div>
          <div className="col-md-12">
            <FormInput
              label="Card Holder Name"
              placeHolder="Enter Card Holder Name"
              type="text"
              value={paymentData.cardHolderName}
              onchange={(e) =>
                setPaymentData({
                  ...paymentData,
                  cardHolderName: e.target.value,
                })
              }
              required
            />
          </div>
          <div className="col-md-6">
            <FormInput
              label="Expiry Date"
              placeHolder="MM/YY"
              type="text"
              value={paymentData.expiryDate}
              onchange={handleExpiryDateChange}
              required
            />
          </div>
          <div className="col-md-6">
            <FormInput
              label="CVV"
              placeHolder="XXX"
              type="text"
              value={paymentData.cvv}
              onchange={handleCvvChange}
              required
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
}

export default SubscriptionModal;